export const config = {
  bugsinkDsns: {
    dev: 'https://a34fd4e8cfc04c5180069b53b5150838@bugsink.high.coms-dev.aws.de.pri.o2.com/4',
    prod: undefined,
  },
};
